export enum TIME_TYPES {
  HOURS_12 = 'HOURS_12',
  HOURS_24 = 'HOURS_24'
}